import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { PMEPriceUpdate } from '@app/lists/model/pme-price-update.model';
import { ProductRow } from '@app/lists/shared/list-detail-management/model/list-detail-management-view.model';

@Component({
  selector: 'app-usf-pme-product-card',
  templateUrl: './usf-pme-product-card.component.html',
  styleUrls: ['./usf-pme-product-card.component.scss'],
})
export class UsfPmeProductCardComponent {
  @Input() index: number;
  @Input() product: ProductRow;
  @Input() isOnline: boolean;
  @Input() screenWidth: number;

  @Output() clicked = new EventEmitter<ProductRow>();
  @Output() priceChanged = new EventEmitter<PMEPriceUpdate>();
  @Output() itemNoteClick = new EventEmitter<ProductRow>();

  @ViewChild('popover') popover!: HTMLIonPopoverElement;

  isPopoverOpen = false;
  constructor() {}

  onProductClick() {
    this.clicked.emit(this.product);
  }

  selectTargetPrice(): void {
    this.priceChanged.emit({
      product: this.product,
      price: this.product.easyPricingViewModel.targetCasePrice,
      isCustom: false,
    });
  }

  onCustomPriceChange(event: Event) {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    const customPrice = parseFloat(value.replace(/[^0-9.]/g, ''));

    if (customPrice) {
      this.priceChanged.emit({
        product: this.product,
        price: customPrice,
        isCustom: true,
      });
    }
  }

  itemNoteClicked() {
    this.itemNoteClick.emit(this.product);
  }

  openPopover(event: Event) {
    this.popover.event = event;
    this.isPopoverOpen = true;
  }
}
